var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.308 6.554C9.713 6.287 9.072 6 8 6c-4 0-5 4-5 8s3 9 5 9c1.172 0 2-.343 2.686-.627.486-.201.9-.373 1.314-.373.414 0 .828.172 1.314.373C14 22.657 14.828 23 16 23c1.428 0 3.365-2.548 4.357-5.461.1-.294-.104-.596-.403-.677a4.002 4.002 0 0 1-.284-7.636c.296-.104.478-.427.339-.708C19.26 7.008 18.008 6 16 6c-1.072 0-1.713.287-2.308.554-.515.23-.996.446-1.692.446s-1.177-.215-1.692-.446ZM12 4.75A3.75 3.75 0 0 1 15.75 1a.25.25 0 0 1 .25.25A3.75 3.75 0 0 1 12.25 5a.25.25 0 0 1-.25-.25Z",
    fill: "#777E91"
  })));
};
export default SvgFilled;